import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'
import './style.css'
import App from './App.vue'
import router from '@/views'
import { hoverDirective } from './directives/hover'
import { createPinia } from 'pinia'
import { i18n } from './utils/i18n'

const pinia = createPinia()

pinia.use(createSentryPiniaPlugin())

const app = createApp(App)

Sentry.init({
	app,
	dsn: 'https://fec4b199cf6ae87a6ed1eb179a7eb743@sentry.rage.gift/3',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	integrations: [
		Sentry.browserTracingIntegration({ router }),
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false
		}),
		Sentry.vueIntegration({
			tracingOptions: {
				trackComponents: true
			}
		})
	],
	// Enable logs to be sent to Sentry
	enableLogs: true,
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	// We recommend adjusting this value in production
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
	tracesSampleRate: 0.1,
	// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
	// Excludes: rage.gift/cdn/*, config.ton.org/*, t.me/*
	tracePropagationTargets: [/^https:\/\/rage\.gift(?!\/cdn)/],
	// Capture Replay for 1% of all sessions,
	// plus for 100% of sessions with an error
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
	replaysSessionSampleRate: 0.01,
	replaysOnErrorSampleRate: 1.0
})

hoverDirective(app)

app.use(i18n).use(pinia).use(router).mount('#app')
